import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllDeliveryBoys, deleteDriver } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
const PAGE_LIMIT = 2000
const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const VendorsTable = (props) => {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [page, setPage] = useState(1);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);

  useEffect(() => {
    props.getAllDeliveryBoys(1);
  }, []);

  const handleDelete = (id) => {
    props.deleteDriver(id).then((data) => {
      if (data) {
        props.getAllDeliveryBoys(1);
      }
    });
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getAllDeliveryBoys(value);
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Delivery Boys - Add, Update, Delete
        </h4>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Username</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.allDrivers?.map((item, i) => (
            <tr key={item.id}>
              <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
              <td>{item.name}</td>
              <td>{item.username}</td>
              <td>
                <Link
                  style={{ color: '#000' }}
                  to={'/admin/edit-driver/' + item.id}
                >
                  <EditIcon />
                </Link>
              </td>
              <td>
                <DeleteIcon
                  style={{ cursor: 'pointer' }}
                  onClick={function (event) {
                    toggle();
                    setItemDelete(item.id);
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Delivery Boy??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modal2} toggle={toggle2}>
        <ModalHeader toggle={toggle2}>Modify a vendor</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to="/admin/add-driver">
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ fontWeight: 600, marginTop: '22px' }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allDrivers: state.admin.allDrivers,
  pageCount: state.admin.pageCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllDeliveryBoys: (id) => dispatch(getAllDeliveryBoys(id, PAGE_LIMIT)),
    deleteDriver: (vendorId) => dispatch(deleteDriver(vendorId))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(VendorsTable);
